import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import { Col, Row, Tab, Tabs } from 'react-bootstrap'
import SupportTask1 from 'components/shared/supportStaffV2/SupportTask1'
import { Breadcrumbs } from 'components/Common/Common'
import { dateFormat } from 'helpers/common'
import { useGetSingleTaskPlanQuery } from 'store/services/V2/supportStaff'
import NotesComponentV2 from 'components/shared/FormComponents/V2/Notes/NotesComponentV2'

function SupportStaffTaskClient() {
    const [activeTab, setActiveTab] = useState("task1");
    const { id: supportStaffId, taskPlanId, clientId } = useParams()

    const { data, isLoading, refetch: taskPlanRefetch } = useGetSingleTaskPlanQuery({ id: taskPlanId, clientId }, { skip: !taskPlanId })


    const supportStaffName = `${data?.support_staff?.firstname} ${data?.support_staff?.lastname}`
    const clientName = `${data?.client?.client_detail?.firstname} ${data?.client?.client_detail?.lastname}`

    return (
        <div >
            {
                isLoading ? <LoadingIndicator /> :
                    <Row>
                        <Col xs="12" md="9">
                            <div style={{ background: "#93278F0D" }} className='px-4 py-3'>
                                <div className='d-flex flex-column gap-3'>
                                    <Breadcrumbs items={[{ label: supportStaffName, path: `/client/support-staff/task/${supportStaffId}`, }, { label: clientName, path: "" }]} style={{ fontSize: "14px" }} />

                                    <div className="support-staff-container">
                                        <h3 className='support-staff-inner-heading'>CLIENT INFORMATION</h3>

                                        <Row>
                                            <Col xs="4">
                                                <h4 className='support-staff-text-head'>Last Name</h4>
                                                <span className='support-staff-text-content'>{data?.client?.client_detail?.firstname}</span>
                                            </Col>
                                            <Col xs="4">
                                                <h4 className='support-staff-text-head'>First Name</h4>
                                                <span className='support-staff-text-content'>{data?.client?.client_detail?.lastname}</span>
                                            </Col>
                                            <Col xs="4">
                                                <h4 className='support-staff-text-head'>Client Type</h4>
                                                <span className='support-staff-text-content'>{data?.client_type == 'home_education' ? 'Home Education' : 'School'}</span>
                                            </Col>
                                        </Row>

                                        <Row>
                                            {
                                                data?.client_type == 'school' && <Col md="10">
                                                    <h4 className='support-staff-text-head'>School</h4>
                                                    <span className='support-staff-text-content'>{data?.school?.name}</span>
                                                </Col>
                                            }
                                            <Col md="2" className={`d-flex flex-column ${data?.client_type == 'school' ? 'align-items-end' : ''}`}>
                                                <h4 className='support-staff-text-head'>Grade</h4>
                                                <span className='support-staff-text-content'>{data?.client_grade}</span>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="py-0 support-staff-container">
                                        <Col lg="12">
                                            <NotesComponentV2 client_id={taskPlanId} module={'task-plan'} />
                                        </Col>
                                    </div>

                                </div>


                                <div style={{ marginTop: "16px" }}>
                                    <h3 className='support-staff-heading'>{data?.plan_name}</h3>

                                    <Tabs
                                        activeKey={activeTab}
                                        onSelect={(k) => setActiveTab(k)}
                                        className="staff-task-tabs full-width-tabs"
                                    >
                                        {
                                            data?.tasks?.map((item, taskIndex) => (
                                                <Tab eventKey={`task${taskIndex + 1}`} title={`Task ${taskIndex + 1}`}>
                                                    <div className="bg-white">
                                                        <SupportTask1
                                                            data={item}
                                                            tasks={data}
                                                            sessionsCount={data?.no_of_sessions}
                                                            taskPlanRefetch={taskPlanRefetch}
                                                            taskIndex={taskIndex}
                                                        />
                                                    </div>
                                                </Tab>
                                            ))
                                        }
                                    </Tabs>
                                </div>
                            </div>
                        </Col>

                        <Col md="3">
                            <div className='pb-3 px-3 px-md-0 pt-5 d-flex flex-column gap-3' style={{ width: "320px" }}>
                                <div className='d-flex flex-column gap-1'>
                                    <h4 className='support-staff-text-head'>Start Date</h4>
                                    <span className='support-staff-text-content'>{dateFormat(data?.start_date, "MMM DD, YYYY")}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <h4 className='support-staff-text-head'>End Date</h4>
                                    <span className='support-staff-text-content'>{dateFormat(data?.end_date, "MMM DD, YYYY")}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <h4 className='support-staff-text-head'>Number of Tasks</h4>
                                    <span className='support-staff-text-content'>{data?.tasks?.length}</span>
                                </div>
                                <div className='d-flex flex-column gap-1'>
                                    <h4 className='support-staff-text-head'>Number of Sessions</h4>
                                    <span className='support-staff-text-content'>{data?.no_of_sessions}</span>
                                </div>

                                {/*                 
                                            <div className="support-divider">
                                                <h3 className="support-staff-inner-heading">CLINICIAN NOTES</h3>
                                            </div> 
                                            <div className="d-flex flex-column gap-3">
                                                {notes.map((note, index) => (
                                                    <div key={index} className="">
                                                        <h4 className="support-staff-inner-heading">{note.date}</h4>
                            
                                                        <div className="d-flex align-items-center gap-2">
                                                            <div className=" support-staff-dis">{note.initials}</div>
                                                            <img src={dummyProfile} alt="" />
                                                            <span className='support-staff-name'>Firstname Lastname</span>
                                                        </div>
                                                        <p className="support-note-text">{note.text}</p>
                                                    </div>
                                                ))}
                                            </div> 
                                            <div className="d-flex flex-column align-items-end gap-2 mt-2">
                                                <h3 className="support-staff-inner-heading text-start w-100"> Notes</h3>
                            
                            
                                                <textarea className="support-note-textarea w-100" rows={8} />
                                                <CommonButton text='Add Note' className='staff-button-filled' cla />
                            
                                            </div> */}
                            </div>
                        </Col>
                    </Row>
            }

        </div>
    )
}

export default SupportStaffTaskClient
